var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-2 fill-height",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('w-jumbotron',{attrs:{"heading":_vm.heading,"desc":_vm.desc}})],1)],1),_c('v-row',[_c('v-col',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }